import { render, staticRenderFns } from "./ModalPodloga.vue?vue&type=template&id=4611c0a6&scoped=true&"
import script from "./ModalPodloga.vue?vue&type=script&lang=js&"
export * from "./ModalPodloga.vue?vue&type=script&lang=js&"
import style0 from "./ModalPodloga.vue?vue&type=style&index=0&id=4611c0a6&prod&lang=css&"
import style1 from "./ModalPodloga.vue?vue&type=style&index=1&id=4611c0a6&prod&scoped=true&lang=css&"
import style2 from "./ModalPodloga.vue?vue&type=style&index=2&id=4611c0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4611c0a6",
  null
  
)

export default component.exports